import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import UiDate from '@/modules/ui/components/ui/UiDate.vue';

type SchemaDateArgs = SchemaControlArgs & {
  placeholder?: string;
  drops?: 'down' | 'up';
};

export class SchemaDate extends SchemaControl<string> {
  readonly component = UiDate;
  readonly placeholder?: string;
  readonly drops?: 'down' | 'up';

  constructor(args: SchemaDateArgs) {
    super(args);

    this.placeholder = args.placeholder;
    this.drops = args.drops;
  }
}
